import { render, staticRenderFns } from "./DriveIndex.vue?vue&type=template&id=05ec639c&scoped=true"
import script from "./DriveIndex.vue?vue&type=script&lang=js"
export * from "./DriveIndex.vue?vue&type=script&lang=js"
import style0 from "./DriveIndex.vue?vue&type=style&index=0&id=05ec639c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec639c",
  null
  
)

export default component.exports